
import React from "react";
import { Link } from "react-router-dom";

const Addressdata = ({ id, type, checked, onChange, address, city, zip }) => {
	return (
		<label className="card1">
			<input
				name="plan"
				className="radio"
				type="radio"
				checked={checked}
				onChange={() => onChange(id)}
			/>
			<span className="plan-details">
				<div className="social-office-content">
					<h4>{type}</h4>
					<div className="social-office">
						<Link to="/edit-address" className="edit-form-wrap">
							<i className="fa-solid fa-pen"></i>
						</Link>
						<Link href="#">
							<i className="fa-solid fa-trash"></i>
						</Link>
					</div>
				</div>
				<div className="address-wrapper-profile">
					<ul>
						<li>
							<p>{address}</p>
						</li>
						<li>
							<h4>{city}</h4>
						</li>
						<li>
							<h4>{zip}</h4>
						</li>
					</ul>
				</div>
			</span>
			<span className={`custom-radio ${checked ? "checked" : ""}`}></span>
		</label>
	);
};

export default Addressdata;
